import { render, staticRenderFns } from "./ProductSingleExtras.vue?vue&type=template&id=044975b4&"
import script from "./ProductSingleExtras.vue?vue&type=script&lang=js&"
export * from "./ProductSingleExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports